import { render, staticRenderFns } from "./tp3Grid.vue?vue&type=template&id=18d8c120"
import script from "./tp3Grid.vue?vue&type=script&lang=js"
export * from "./tp3Grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports